import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef } from'@angular/core';
import { HttpClient } from'@angular/common/http';
import { NbDialogService } from'@nebular/theme';
import { CookieService } from'ngx-cookie-service';
import * as _ from'lodash';

@Component({
  selector:'app-select-stores',
  templateUrl:'./select-stores.component.html',
  styleUrls: ['./select-stores.component.scss']
})
export class SelectStoresComponent implements OnInit {
  @Output() emitClose = new EventEmitter();
  @Output() emitList = new EventEmitter();
  @Input() orgData: Array<any>;
  @Input() StoreList: string;
  @Input() index: number;
  
  //---------"與父組件共用，不可改位址------->---------------------
  @Input() ProductList: Array<any>;  //細項清單

  //-----------------------彈窗----------------------------

  modalRef = null;  //彈窗鉤子
  PdModalRef = null;  //彈窗鉤子

  @ViewChild('Modal') Modal :TemplateRef<any>
  @ViewChild('PdModal') PdModal :TemplateRef<any>

  //--------------------------------------------------------
  //資料清單
  mainDataList: Array<any>; //已選資料
  showList: Array<any>;
  query = {  //查詢選項
    searchKey : "",
    ORG_Company_ID:null
  } 
  status: { //當前狀態
    isSelectAll : boolean //是否已全選
    showType:number // 顯示有選過的
  }
  isChecked: boolean = false;
  selectORG_Store_ID: number = null;
  constructor(
    private dialogService: NbDialogService,
    private http: HttpClient,
    private cookieService: CookieService,
  ) 
  {
    this.query.ORG_Company_ID = parseInt(this.cookieService.get('ORG_Company_ID'))
    this.selectORG_Store_ID = parseInt(this.cookieService.get('selectORG_Store_ID'))
  }


  ngOnInit(): void {
  }


  ngAfterViewInit(){   
    this.onOpen(this.orgData, this.StoreList)
  }


  onOpen(dataList: any[], storeListString: string) {
    this.mainDataList = _.cloneDeep(dataList);
  
    const selectedStoreIds = storeListString ? storeListString.split(',').map(Number) : [];
    var all = []
    if (this.selectORG_Store_ID != null){
      all.push(this.selectORG_Store_ID)
    }
    this.mainDataList = this.mainDataList.filter(item => !all.includes(item.value)),
    this.mainDataList = this.mainDataList.map(e => ({
      ...e,
      isChecked: selectedStoreIds.includes(e.value)
    }));
  
    // 開啟彈窗
    this.modalRef = this.dialogService.open(this.Modal, {});
    this.modalRef.onClose.subscribe(result => {
      this.emitClose.emit(true);
    });
  }

  //處存區塊
  onSave() {
    const selectedItems = this.mainDataList.filter(e => e.isChecked === true);
    this.emitList.emit({
      filteredList: selectedItems,
      index: this.index
    });
    this.modalRef.close();
  }
  

}
